import React from 'react';
import { DashboardLayout } from './DashboardLayout';
import { DashboardHome } from './DashboardHome';
import { ParticipantPreview } from './ParticipantPreview';
export function DashboardPage() {
  return <DashboardLayout pageTitle="Dashboard" breadcrumb="Leadership Reset Retreat" data-id="element-1404">
      <DashboardHome data-id="element-1405" />
      <div className="mt-8" data-id="element-1406">
        <ParticipantPreview data-id="element-1407" />
      </div>
    </DashboardLayout>;
}